import React, { lazy, Suspense, useMemo } from 'react';
import cn from 'classnames';
import Container from 'components/UI/Container';
import Title from 'components/UI/Title';
import Subtitle from 'components/UI/Subtitle';
import CardsGrid from './CardsGrid';
import MobileSlider from 'components/MobileSlider';
import BentoCard from './BentoCard';
import Alert from 'components/UI/Alert';
import Button from 'components/UI/Button';
import { useStateModal, useWindowResize } from 'utils/hooks';
import { withErrorBoundary } from 'components/ErrorBoundary';

import * as styles from './BentoBlock.module.scss';

const RequestServicesModal = lazy(() => import('components/Modals/RequestServicesModal'));

function BentoBlock({ title, subtitle, items, alert }) {
  const { modalState, showModal, hideModal } = useStateModal();
  const { width } = useWindowResize();
  const isCardsWithLinks = items.some(card => card?.link !== undefined);

  const services = useMemo(() => items.map(item => item.title), [items]);

  return (
    <Container>
      <div className={cn(styles.layout, isCardsWithLinks && styles.cardsWithLinks)}>
        <Title>{title}</Title>
        <Subtitle size="lg">{subtitle}</Subtitle>
        {width > 544 ? (
          <CardsGrid cards={items} />
        ) : (
          <MobileSlider
            id="bentoSlide"
            className={styles.mobileWrapper}
            items={items}
            CardComponent={BentoCard}
          />
        )}
        {alert && (
          <>
            <Alert
              className={styles.alert}
              theme="large"
              background="white"
              icon={null}
              shadow={true}
              content={alert.notificationText}
              Button={
                <Button onClick={showModal} fullWidthMobile>
                  {alert.btnText}
                </Button>
              }
            />
            <Suspense fallback={null}>
              <RequestServicesModal
                title={alert.btnText}
                services={services}
                isOpen={modalState.isOpen}
                closeModalCallback={hideModal}
                animation="show"
              />
            </Suspense>
          </>
        )}
      </div>
    </Container>
  );
}

BentoBlock.displayName = 'BentoBlock';

export default withErrorBoundary(BentoBlock);
